import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import _ from 'lodash';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { ModalComponent } from '../../shared/modal/modal.component';
import { CustomFormControl } from '../../shared/shared.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputMaskModule } from 'primeng/inputmask';
import { MessageService } from 'primeng/api';
import { CreateUuidService } from '../../services/create-uuid/create-uuid.service';

@Component({
  selector: 'app-authorization',
  imports: [InputTextModule, CommonModule, FormsModule, ButtonModule, SelectModule, ReactiveFormsModule, DropdownModule, PanelModule, ModalComponent, MultiSelectModule, InputMaskModule],
  templateUrl: './authorization.component.html',
  styleUrl: './authorization.component.scss'
})

export class AuthorizationComponent implements OnInit {
  @ViewChild('stepHeading') stepHeading!: ElementRef;
  @ViewChildren('opposingHeaders') opposingHeaders!: QueryList<ElementRef>;
  @Input() subjects: any;
  @Input() formData: any;
  @Input() states: any;
  @Input() editOrder: any;
  @Output() formChanged = new EventEmitter<void>();
  formGroup!: FormGroup;
  subjectNames: any[] = [];
  originalSubjectNames: any[] = [];
  showDeleteModal: boolean = false;
  itemToDelete: any;
  showAddPartyModal = false;
  partyNames: string[] = [''];
  partyName = '';
  selectedPartyIndex: number = 0;
  selectedPartyType: string = 'plaintiff';
  modalContext: 'plaintiff' | null = null;
  showValidationErrors: boolean = false;

  constructor(private cdr: ChangeDetectorRef, private messageService: MessageService,
    private readonly uuidService: CreateUuidService
  ) { }

  ngOnInit(): void {
    if (this.subjects) {
      let nameList = _.map(_.get(this.subjects, 'subjects'), item => ({
      name: item.recordSubjectName,
      value: item.recordSubjectName,
      keys: item.keys ?? {}
    }));
      if (nameList && !_.isNull(nameList[0])) {
        this.subjectNames = nameList;
        this.originalSubjectNames = [...nameList];  
      }

    }

    this.formGroup = new FormGroup({
      'authorizations': new FormArray([this.createAuthorizationFormGroup()]),
      'caseNumber': new FormControl(null)
    });

    if(this.formData) {
      this.initializeFormData();
    } 

    const recordSubjectArray = this.formGroup.get('authorizations') as FormArray;

if (recordSubjectArray && recordSubjectArray.length > 0) {

  for (let i = 0; i < recordSubjectArray.length; i++) {

    const group = recordSubjectArray.at(i);
    const currentSelections = group.get('recordSubjectName')?.value ?? [];
    const options = this.originalSubjectNames;

    const matchedSelections = currentSelections.filter((sel: any) =>
      options.some((opt: any) => opt.value === sel.value)
    );

    const unmatchedOptions = options.filter((opt: any) =>
      !currentSelections.some((sel: any) => sel.value === opt.value)
    );

    this.originalSubjectNames = [...matchedSelections, ...unmatchedOptions];

    const control = group.get('recordSubjectName');

    if (control) {
      const currentValue = control.value;

      if (currentSelections && currentSelections.length > 0) {
        control.setValue(currentSelections, { emitEvent: false });
      } else if (!currentValue || (Array.isArray(currentValue) && currentValue.length === 0)) {
        control.setValue(this.subjectNames, { emitEvent: false });
      }
    }
  }
}


    this.formGroup.valueChanges.subscribe(()=>{
      this.formChanged.emit();
    });
  }

  // add focus to the top header 
  ngAfterViewInit() {
    setTimeout(() => {
      this.stepHeading.nativeElement.focus();
    });
  }

  /**
   * Gets the authorizations form array.
   * @returns The FormArray of authorizations.
   */
  get authorizations(): FormArray {
    return this.formGroup.get('authorizations') as FormArray;
  }

  getOptionsForGroup(group: FormGroup) {
  const current = group.get('recordSubjectName')?.value ?? [];
  const options = [...this.originalSubjectNames];

  const matched = current.filter((sel: any) =>
    options.some(opt => opt.value === sel.value)
  );

  const unmatched = options.filter(opt =>
    !current.some((sel: any) => sel.value === opt.value)
  );

  return [...matched, ...unmatched];
}

  /**
   * Adds a new authorization to the authorizations form array.
   */
  addAuthorization(): void {
    const group = this.createAuthorizationFormGroup();

    const recordSubjectNameControl = group.get('recordSubjectName');

    recordSubjectNameControl?.valueChanges.subscribe((selectedValue) => {
    const components = group.get('keys')?.value?.components;

    if (selectedValue && components && typeof components === 'object') {
      const componentKey = Object.keys(components).find(key => key === 'external-id');

      if (componentKey) {
        selectedValue.keys = componentKey; 
      }
    }
  });
    this.authorizations.push(group);

    // add focus to newly added counsel
    this.cdr.detectChanges();
    setTimeout(() => {
      const headersArray = this.opposingHeaders.toArray();
      const newHeader = headersArray[headersArray.length - 1];
      newHeader.nativeElement.focus();
    });
  }

  /**
   * Removes a authorization from the authorizations form array.
   * @param index The index of the authorization to remove.
   */
  removeAuthorization(index: number) {
    // this.authorizations.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  createAuthorizationFormGroup(item?: any): FormGroup {
    const existingKeys = Array.isArray(item?.keys) ? [...item.keys] : [];
    let keys = this.uuidService.generatePartyExternalId(existingKeys);

    if (Array.isArray(item?.recordSubjectName)) {

      item.recordSubjectName = item.recordSubjectName.map((subject: any) => {

        if(!this.subjectNames.find(s => s.name === subject.name)) {
        const defNewOptions = { name: subject.name, value: subject.name, keys: subject.keys };
        this.originalSubjectNames = [...this.originalSubjectNames, defNewOptions];
      }

        subject = { name: subject.name, value: subject.name, keys: subject.keys };
        return subject;
      });
    }
    // let selectedSubjects: any[] = [];

    // if (item?.recordSubjectName && this.subjectNames?.length) {
    //   selectedSubjects = this.subjectNames.filter((opt) =>
    //     item.recordSubjectName.some(
    //       (s: any) =>
    //         s.name?.trim().toLowerCase() === opt.name?.trim().toLowerCase()
    //     )
    //   );
    // }

    return new FormGroup({
      'recordSubjectName': new CustomFormControl(item ? item?.recordSubjectName : null, 'Plantiff Representing', [Validators.required]),
      'opposingCounselAttorneyName': new CustomFormControl(item ? item?.opposingCounselAttorneyName : null, 'Plantiff Counsel Full Name', [Validators.required]),
      'opposingCounselBarNumer': new CustomFormControl(item ? item?.opposingCounselBarNumer : null, 'Plantiff Bar Number'),
      'opposingCounselFirmName': new CustomFormControl(item ? item?.opposingCounselFirmName : null, 'Plantiff Law Firm', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item ? item?.fax : null),
      'email': new CustomFormControl(item ? item?.email : null, 'Email', [Validators.email]),
      'isNew': new FormControl(item ? item.isNew : true),
      'keys': new FormControl(keys)
    });
  }

  isError(controlId: any, control?:any) {
    let formControl = this.formGroup.get(controlId);
    if(!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  delete() {
    if(this.itemToDelete >= 0) {
      this.authorizations.removeAt(this.itemToDelete);
      this.itemToDelete = null;
      this.showDeleteModal = false;
      this.messageService.add({
        severity: 'success',
        summary: 'SUCCESS',
        detail: `Opposing Counsel successfully deleted.`,
        life: 3000,
      });
    }
    
  }

  initializeFormData() {
    if (this.formData?.authorizations) {
      this.authorizations.clear();
      _.forEach(this.formData.authorizations, subject => {
        this.authorizations.push(this.createAuthorizationFormGroup(subject));
      });
    }
  
    if (this.formData?.caseNumber) {
      this.formGroup.get('caseNumber')?.setValue(this.formData.caseNumber);
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  addMoreInput(event: Event) {
    event.preventDefault(); 
    this.partyNames.push('');
  }
  
  openAddPartyModal(context: 'plaintiff', index: number) {
    this.selectedPartyType = context;
    this.selectedPartyIndex = index;
    this.modalContext = context;
    this.partyNames = [''];
    this.showAddPartyModal = true;
    this.showValidationErrors = false;
    this.cdr.detectChanges();
  }

  saveParty() {
    this.showValidationErrors = false;
    const validNames = this.partyNames.map(name => name?.trim()).filter(name => !!name);
  
    if (validNames.length === 0) {
      this.showValidationErrors = true;
      return;
    }
  
    if (this.selectedPartyType === 'plaintiff') {
      validNames.forEach(name => {
        this.originalSubjectNames = [...this.originalSubjectNames, { name, value: name }]; 
      });
      const control = (this.formGroup.get('authorizations') as FormArray).at(this.selectedPartyIndex);
      const currentSelection = control.get('recordSubjectName')?.value || [];
  
      control.get('recordSubjectName')?.setValue([...currentSelection, ...validNames.map(name => ({ name,
      value: name }))]);
    }
    this.showAddPartyModal = false;
  }
  
  
  onModalCancel() {
    this.showAddPartyModal = false;
    this.partyNames = [''];
    this.modalContext = null;
  }

}
